import React, { useEffect, useState } from "react";
import "./OtpPage.css";
import { Form, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { sendOtprequest } from "../../otpverification/util/sendOtp";
import { connect } from "react-redux";
import { fetchLogindata } from "../../login/redux/actions";
import { loginWithotprequest } from "../util/loginWithotp";
import { registerrequest } from "../../signup/util/register";
import { toast } from "react-toastify";
// import { getOtpverifyrequest } from "../util/otpVerification";
import { updateCartrequest } from "../util/updateCart";
import { maintainCartdata } from "../../home/redux/actions";
import { useTranslation } from "react-i18next";
import { maintanCheckoutpage } from "../../home/redux/actions";
import { formatPhoneNumber } from "../../comman/components/TimeSence";
import { formatPhoneNumberturkish } from "../../comman/components/TimeSence";
import { postRequestcall } from "../../comman/util/postRequest";
import { SEND_NOTIFICATION } from "../../constants/apiurl";
import FormgroupPage from "../../comman/formgroup/FormgroupPage";
import { maintainCabbook } from "../../home/redux/actions";

function OtpPage(props) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [couter, setCounter] = useState(120);
  const [otp, setOtp] = useState("");
  const [errorMsg, setErrormsg] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isTimerRunning, setIsTimerRunning] = useState(true);
 
  // eslint-disable-next-line
  useEffect(() => {
    (async () => getOtp())();
    // eslint-disable-next-line
  }, [props.showotp]);
  useEffect(() => {
    if (isTimerRunning) {
      const intervalId = setInterval(() => {
        setCounter(couter => couter - 1);
      }, 1000);

      return () => clearInterval(intervalId);
    }
  }, [isTimerRunning]);

  useEffect(() => {
    if (couter === 0) {
      setIsTimerRunning(false);
    }
  }, [couter]);

  const getOtp = () => {
    if (props.showotp) {
      //callingOTP(props.inputvalue.mobile, props.inputvalue.country_code);
      // timeCounter();
      setCounter(120);
    }
  };

  const resendOtp = async (e) => {
    e.preventDefault();
    callingOTP(props.inputvalue.mobile, props.inputvalue.country_code)
    setCounter(120);
  };

  const callingOTP = async (value, country_code) => {
    let sendOtpresponse = await sendOtprequest(
      value,
      country_code,
      props?.language?.toLowerCase()
    );
    if (sendOtpresponse?.status === 200 || sendOtpresponse?.status === 201) {
      let res = await sendOtpresponse.json();
      SendOTPResponce(res);
      // timeCounter();
    }
  };

  // const timeCounter = () => {
  //   var timeleft = 120;
  //   setCounter(timeleft);
  //   var downloadTimer = setInterval(function () {
  //     if (timeleft <= 0) {
  //       clearInterval(downloadTimer);
  //     }
  //     timeleft -= 1;
  //     setCounter(timeleft);
  //   }, 1000);
  // };

  const SendOTPResponce = async (result) => {
    if (result.data?.mobile_already_exist === "yes") {
      props?.setMobileexist(true);
    } else {
      props?.setMobileexist(false);
    }
  };

  const timeout = (e) => {
    e.preventDefault();
    alert(t("pages.otp_page.timeout_warn"));
  };

  const inputvalueChange = (e) => {
    if(e.target.value?.length<=4){
      setOtp(e.target.value);
    }
    setErrormsg(false);
  };

  const callLogin = async (e) => {
    try {
      e.preventDefault();
      if (otp === "") {
        setErrormsg(true);
      } else {
        //if (otp.length === 4) {
        setLoader(true);
        if (props?.mobileexist) {
          // If mobile already exit go to login without verify otp
          await forLogin();
        } else {
          // let getOtpverifyresponse = await getOtpverifyrequest(
          //   props.inputvalue.mobile,
          //   otp,
          //   props.inputvalue.country_code,
          //   props.language.toLowerCase()
          // );
          // if (getOtpverifyresponse?.status === 200) {
            if (window.location.pathname.split("/").pop() === "signup") {
              forSignup();
            } else if (
              window.location.pathname.split("/").pop() === "partner"
            ) {
              forVendorsignup();
            } else {
              if (props.logintype === "customer") {
                navigate("/signup", {
                  state: {
                    fromlogin: true,
                    mobilenum: props.inputvalue.mobile,
                    country_code: props.inputvalue.country_code,
                    country_isocode: props.inputvalue.country_isocode,
                  },
                });
              } else {
                navigate("/partner", {
                  state: {
                    fromlogin: true,
                    mobilenum: props.inputvalue.mobile,
                    country_code: props.inputvalue.country_code,
                    country_isocode: props.inputvalue.country_isocode,
                  },
                });
              }
              setLoader(false)
            }
          // } else if (getOtpverifyresponse.status === 400) {
          //   let res = await getOtpverifyresponse.json();
          //   if (res?.errors) {
          //     toast.error(res?.errors);
          //   }
          //   setLoader(false)
          // }
        }
        /*} else {
          toast.error(t("pages.otp_page.Invalid input"));
        }*/
      }
      //setTimeout(() => setLoader(false), 1400);
    } catch (error) {}
  };

  const forLogin = async () => {
    const loginWithotpresponse = await loginWithotprequest(
      props.inputvalue.mobile,
      otp,
      props.inputvalue.country_code,
      props?.language?.toLowerCase()
    );
    if (loginWithotpresponse?.status === 200) {
      let loginData = await loginWithotpresponse.json();      
      props.fetchLogindata(loginData?.data);
      updateCart(loginData);
    } else if (loginWithotpresponse.status === 400) {
      let loginError = await loginWithotpresponse.json();
      toast.error(loginError.error);
      setLoader(false)
    }
  };

  const updateCart = async (loginData) => {
    if(props?.cartdata?.length > 0) {
      let object = {};
      let productlist = [];
      props?.cartdata?.forEach((product) => {
        object = {
          store_id: product?.store_id,
          product_id: product?.product_id,
          variation_id: product?.variation_id,
          quantity: product?.quantity,
          id: product?.id,
        };
        productlist.push(object);
      });
      let data = {
        cartdata: productlist,
      };
      const updateCartresponse = await updateCartrequest(
        loginData?.data?.token?.access_token,
        data,
        props?.language?.toLowerCase()
      );
      if (updateCartresponse?.status === 200) {
        navigateTologin(loginData);
      }else if (updateCartresponse?.status === 400) {
        let getErrormsg = await updateCartresponse.json();
        toast.error(getErrormsg?.errors);
        props.maintainCartdata([], {});
        navigateTologin(loginData);
      }
    } else {
      navigateTologin(loginData);
    }
    setLoader(false)
  };

  const navigateTologin = (loginData) => {
    if (props?.navigatecheckout === "checkout") {
      // Before login flow navigate to checkout page
      navigate("/checkout");
    } else if (props?.navigatecheckout === "cart") {
      // Before login flow navigate to shopping cart page
      props.maintanCheckoutpage("");
      navigate("/cart");
    } 
    else if (props?.navigateCabbook?.flag === "cab_book") {
      let getId = props?.navigateCabbook?.id;
      navigate(`/cab-book/${getId}`);
      props.maintainCabbook({flag:"",id:""});
   }
   else {
      if (
        props?.mobileexist === true &&
        (props?.page_from === "signup" || props?.page_from === "vendor")
      ) {
        toast.info(t("pages.Your number already registered login successful"));
      }
      if (loginData?.data?.type === "user") {
        navigate("/");
      } else {
        navigate("/vendor/dashboard");
      }
    }
  };

  const forSignup = async () => {
    let registerInput = {
      first_name: props.inputvalue.fullname,
      mobile: props.inputvalue.mobile,
      email: props.inputvalue.email,
      password: props.inputvalue.password,
      type: "user",
      otp:otp,
      lang: props?.language?.toLowerCase(),
      lat: props?.currentLocation?.lat,
      lng: props?.currentLocation?.lng,
      address: props?.currentLocation?.address,
      zip_code: props?.currentLocation?.zip_code,
      country_code: props.inputvalue.country_code,
      image:"",
    };
    let registerResponse = await registerrequest(registerInput);
    if (registerResponse?.status === 200) {
      let loginData = await registerResponse.json();
      props.fetchLogindata(loginData.data);
      updateCart(loginData);
    } else if (registerResponse.status === 500) {
      toast.error(t("pages.signup.email_exist"));
      setLoader(false);
    } else if (registerResponse.status === 400) {
      let getValue = await registerResponse.json();
      showServererror(getValue);
      setLoader(false);
    }
  };

  const forVendorsignup = async () => {
    let registerInput = {
      title: props.inputvalue.title,
      address: props.inputvalue.address,
      city: props.inputvalue.city,
      country: props.inputvalue.country,
      zip_code: props.inputvalue.zip_code,
      first_name: props.inputvalue.first_name,
      mobile: props.inputvalue.mobile,
      type: "vendor",
      email: props.inputvalue.email,
      password: props.inputvalue.password,
      lat: props.inputvalue.lat,
      lng: props.inputvalue.lng,
      service_id: null,
      otp:otp,
      image: "",
      images: "",
      store_type: "goods",
      lang: props?.language?.toLowerCase(),
      country_code: props.inputvalue.country_code,
    };
    let registerResponse = await registerrequest(registerInput);
    if (registerResponse?.status === 200) {
      // Navigate to business setup page for edit the current store
      let loginData = await registerResponse.json();
      loginData.data.vendor_type = "";
      props.fetchLogindata(loginData.data);
      navigate(`/vendor/${loginData?.data?.store_id}`);
      setLoader(false);
      await updateCartVendorsignup(loginData);
      await updateSendnotification(loginData);
    } else if (registerResponse.status === 400) {
      let getValue = await registerResponse.json();
      showServererror(getValue);
      setLoader(false);
    } else if (registerResponse.status === 500) {
      toast.error(t("pages.signup.email_exist"));
      setLoader(false);
    }
  };

  const updateSendnotification = async (loginData) => {
    let geturl = SEND_NOTIFICATION + `?type=${"store"}&id=${loginData?.data?.store_id}`
    await postRequestcall(geturl, loginData?.data?.token?.access_token, "");
  }

  const updateCartVendorsignup = async (loginData) => {
    if(props?.cartdata?.length > 0) {
      let object = {};
      let productlist = [];
      props?.cartdata?.forEach((product) => {
        object = {
          store_id: product?.store_id,
          product_id: product?.product_id,
          variation_id: product?.variation_id,
          quantity: product?.quantity,
          id: product?.id,
        };
        productlist.push(object);
      });
      let data = {
        cartdata: productlist,
      };
      const updateCartresponse = await updateCartrequest(
        loginData?.data?.token?.access_token,
        data,
        props?.language?.toLowerCase()
      );
      if (updateCartresponse?.status === 400) {
        let getErrormsg = await updateCartresponse.json();
        toast.error(getErrormsg?.errors);
        props.maintainCartdata([], {});
      }
    }
   
  };

  const showServererror = (getValue) => {
    if (getValue?.errors?.mobile && getValue?.errors?.email) {
      toast.error(
        t(
          "pages.Your mobile and email already been taken please sign up with another email and mobile"
        )
      );
      props.setShowotp(false);
    } else if (getValue?.errors?.mobile) {
      props.setShowotp(false);
      toast.error(t("pages.please sign up with another mobile"));
    } else if (getValue?.errors?.email) {
      props.setShowotp(false);
      toast.error(t("pages.please sign up with another email"));
    }
  };

  return (
    <Form
      className="otp-form"
      style={{
        padding:
          window.location.pathname.split("/").pop() === "partner"
            ? "10px 10px 7rem 10px"
            : "",
      }}
    >
      <div className="form-header">
        <h2>{t("pages.otp_page.title")}</h2>
        <h6>
          {t("pages.otp_page.sending_caption")}
          <br />
          {t("pages.otp_page.mobile_number")} :{" "}
          <strong>
            + {props.inputvalue.country_code}{" "}
            {props.inputvalue.country_code === "91"
              ? formatPhoneNumber(`${props.inputvalue.mobile}`)
              : formatPhoneNumberturkish(`${props.inputvalue.mobile}`)}
          </strong>
        </h6>
      </div>
      <div className="form-content mt-md-2 ">
        <FormgroupPage
          label={couter > 0 && `${couter} ${t("pages.otp_page.time_remaining")}`}
          className="form-group"
          value={otp}
          name={"otp"}
          onChange={(e) => inputvalueChange(e)}
          type="number"
          onWheel={(e) => e.target.blur()}
          placeholder={t("pages.otp_page.input_placc")}
          error={errorMsg && t("pages.otp_page.input_placc")}
          require={false}
        />
        {/* {couter < 0 && ( */}
          <h5>
            {t("pages.otp_page.dont_otp")}{" "}
            <span onClick={(e) => resendOtp(e)}>
              {t("pages.otp_page.resend")}
            </span>{" "}
          </h5>
        {/* )} */}
        <button
          className="otp-btn-verify mt-4"
          onClick={(e) =>
            !loader
              ? couter <= 0
                ? timeout(e)
                : callLogin(e)
              : e.preventDefault()
          }
        >
          {loader ? (
            <Spinner animation={"border"} />
          ) : (
            t("pages.otp_page.submit")
          )}
        </button>
      </div>
    </Form>
  );
}

const mapStateToProps = (state) => ({
  //First we check the logindata is undefined or not using ?
  logindata: state?.login.logindata,
  type: state?.login?.type,
  cartdata: state?.home?.cartdata,
  language: state?.languageState?.language,
  navigatecheckout: state?.home?.navigatecheckout,
  navigateCabbook: state?.home?.navigateCabbook,
  currentLocation: state?.home?.currentLocation,
});

export default connect(mapStateToProps, {
  fetchLogindata,
  maintainCartdata,
  maintanCheckoutpage,
  maintainCabbook
})(OtpPage);
